$(document).ready(function() {
    // Prepend the HTML Content in the body

    // ============= DEFAULT CONTENTS
  
    var qualityMatters_Default = `
      <p>- We spend a third of our life sleeping. 2,891 hours every single year.</p>
      <p>- And quality sleep is one of the MOST important factors in overall health. Did you know that poor sleep triggers insulin resistance, cognitive decline, mental health issues, and has even been linked to cardiovascular disease?</p>
      <p>- Your pillow can make or break the quality of your sleep. We were tired of sleeping on pillows filled with that fall flat, provide no support, and literally cause neck pain and headaches. We’re talking about those those hotel pillows that you need 4 of just to feel supported — yeah, those ones.</p>
      <p>- So we set out to develop the perfect pillow. One that provides the perfect balance of comfort and support. One that keeps aligns your neck and spine in alignment to reduce neck pain and tension headaches. And one that is suitable for all types of sleepers — back, side, stomach, and combination.</p>
      <p>- Dosaze isn’t a discount brand. Dosaze is a premium product (did you know that a mattress built from Dosaze memory foam would cost $4,000?)</p>
      <p>- We exist for the sole purpose of creating your perfect night’s sleep. That’s why we spent 2 years developing this product and perfecting every detail — from the density of the foam, to the shape, to the cover.</p>
      <p>- This will be the best $119 you ever invest in your sleep.</p>
      <p>- The measure of a purchase isn’t the feeling you get when you make it; it’s the feeling you get when you wake up every day, refreshed, and ready to take on the day.</p>
    `;

    var returnProcess_Default = `
      <p>All orders can be returned within 60 days from delivery. We offer a 60-day night sleep trial on all orders, so you are welcome to return the pillow, even after you have used it.</p>
      <p>Buying pillows online can be a very strange process since pillows are naturally a subjective item. We all want to try a pillow before committing to purchase it, and here at Dosaze, we completely understand that.</p>
      <p>That’s why we offer a 60-night sleep trial on all orders so you can test the pillow in the comfort of your own home and eliminate any doubts you may have. Starting from when you receive your package, you have 60 nights!</p>
      <p>If you’re not in love with your purchase during this time period, you have the option to return It to us for a full refund. Simply reach out to <a href="mailto:support@dosaze.com" style="text-decoration:underline;">support@dosaze.com</a> to initiate a return. </p>
    `;

    var howWeDidIt_Default = `
      <p></p>
      <h3>For the side, back, or combination sleeper that wakes up with neck pain and headaches, and is tired of it.</h3>
      <p></p>
      <p>Welcome Home.</p>
      <p>A recent poll showed that 80% of people experience neck pain in their life and an additional 80% experience tension headaches. Poor sleep alignment can be a primary cause of this, but most pillows do nothing to improve that.</p>
      <p>How does that even make sense?</p>
      <p>Of course, that would be okay if we all naturally slept aligned, but you know that isn’t the case.</p>
      <p>Some pillows may keep you aligned if you’re a side sleepers, some others if you’re a back sleeper, but rarely do you come across a pillow that will keep you all sleepers aligned.</p>
      <p>Your body is a solider. It works overtime to undo, correct, and fix your bad habits. The way you sit, the way you walk, and the way you sleep.</p>
      <p>But, like a credit card, your body can only accumulate so much debt before something has to give.</p>
      <p>
        <strong>Here’s what happens when you send a regular pillow to do the job of a Dosaze Contoured Orthopedic Pillow</strong>
      </p>
      <p>
        <img src="https://cdn.shopify.com/s/files/1/0306/1081/7162/files/dosaze-pillow-alignment.png?v=1687190382">
      </p>
      <p>For a number of reasons, these pillows simply do not facilitate aligned sleep.</p>
      <p>First, they <strong>do not provide adequate support</strong>— these pillows are often filled with microfiber or other low quality materials that tend to fall flat when you lie on them. You know, like those hotel pillows that you need to use 3 - 4 of just to feel supported. You can see how this would cause poor alignment. </p>
      <p>Second, the "standard" pillow shape <strong>isn’t catered to the natural alignment of your spine, neck, and head</strong>. In general, you want a pillow that gradually slopes up for a back sleeper. For a side sleeper, you actually want a pillow that is higher in the front and slightly lower in the back, to fit the shape your shoulder and head make together. </p>
      <p>This improper support and alignment are the primary causes of neck pain and tension headaches. You probably have tried other solutions — a new mattress, visits to the chiropractor, and/or pain medication — none of which are cheap and definitely add up over time.</p>
      <p>
        <strong>Enough Already!</strong>
      </p>
      <p>You don’t need more helpful hints, tips, or tricks. You just need a pillow designed with you in mind.</p>
      <p>
        <strong>The "weirdly" shaped pillow</strong>
      </p>
      <p>If you ask a carpenter to make you a table it’s going to be made out of wood. You ask a welder to do it, your table is going to be made out of metal.</p>
      <p>So when the legacy pillow makers try to make a pillow for side sleepers, they get so focused on making it look like a pillow that they forget to focus on the quality of sleep problem.</p>
      <p>We didn’t have that kind of baggage. We didn’t have to unlearn 50 years of pillow design.</p>
      <p>Starting from scratch has its advantages. And the need for a "contoured" pillow was clear to us early.</p>
      <p>The contoured shaped allowed for perfect alignment for side, back, and stomach sleepers (and all combinations).</p>
      <p>The center contour is perfect for keeping your head and neck and alignment when you’re on your back or stomach.</p>
      <p></p>
      <p>If you sleep on your side, the elevated bolsters fill your shoulder gap and the back gradually slopes down to fit the natural curvature of your head:</p>
      <p></p>
      <p>
        <img src="https://cdn.shopify.com/s/files/1/0306/1081/7162/files/dosaze-pillow-alignment-2.png?v=1687190382">
      </p>
      <p></p>
      <p>And the best part? <strong> If you sleep on your back and side, you can roll from the elevated side bolsters to the center contour and maintain your spinal alignment in either position.</strong>
      </p>
      <p>It’s not just about the shape though.</p>
      <p>If it was just the shape that mattered, we would have used microfiber, down, or other materials that aren’t supportive. However, we were on the hunt for the perfect foam blend.</p>
      <p>Not too hard (it would hurt your ear), not too soft (it wouldn’t support your spin), and definitely not something too hot. It needed to be just right.</p>
      <p>We tested ~50 different foam blends and firmness levels with people from all walks of life. Some started off promising and in the end all failed. It was so hard we nearly abandoned the project. In the end we did something experts told us we would never be able to do: we created our own proprietary blend.</p>
      <p>This pillow couldn’t have existed 5 years ago</p>
      <p>There is a reason you didn’t see us when you shopped for your last pillow. The technology behind the Dosaze Contoured Orthopedic Pillow didn’t exist.</p>
      <p>We crafted this pillow to solve the support and alignment issues plaguing us and our loved ones — we saw the issues with current pillows and solved them meticulously one by one.</p>
      <p>We use only the highest CertiPUR-US certified memory foam. In fact the foam used for your Dosaze Contoured Orthopedic Pillow is so high quality that it would retail for <span class="reveal">REVEAL</span> dollars if we were to build a mattress using it. </p>
      <p>
        <strong>If you’ve made it this far, we want to say thank you. Thank you for allowing us to share our journey to create the perfect pillow with you.</strong>
      </p>
      <p>There’s a lot of pressure to buy now, act now. Don’t feel rushed. We aren’t going anywhere. And when you’re ready we look forward to give you the best quality sleep of your lift. If you have any questions, you can reach our cofounders Inno and Sherry directly @ <a href="mailto:inno@dosaze.com">
          <strong>inno@dosaze.com</strong>
        </a> and <a href="mailto:sherry@dosaze.com">
          <strong>sherry@dosaze.com</strong>
        </a> and we can answer any questions you have! </p>
      <p>And if you try it, and our pillow doesn’t help you, no harm no foul. You can try our pillow for 60 nights and get a full refund, no questions asked, if you don’t like it.</p>
      <p>We look forward to you joining the millions that are sleeping better with Dosaze.</p>
    `;

    // ============= CONTENT AVAILABLE
  
    if ($('#QMContent').length > 0) {
        var qualityMatters_Content = $('#QMContent').html();
    } else {
        var qualityMatters_Content = qualityMatters_Default;
    }

    if ($('#RPContent').length > 0) {
        var returnProcess_Content = $('#RPContent').html();
    } else {
        var returnProcess_Content = returnProcess_Default;
    }

    if ($('#HWContent').length > 0) {
        var howWeDidIt_Content = $('#HWContent').html();
    } else {
        var howWeDidIt_Content = howWeDidIt_Default;
    }

    // ============= HTML LAYOUT
  
    var qualityMatters_HTML = `
      <div class="qm qm-matters" style="display:none;">
          <div class="qm-wrapper">
              <a href="#" class="qm-close">
              <i class="fa-thin fa-xmark"></i>
              </a>
              <div class="qm-content">
              ` + qualityMatters_Content + `
              </div>
              <div class="qm-agree">
              <div class="qm-option">Agree with our stance on quality?</div>
              <div class="qm-option">
                  <a href="#" id="qm-answer" class="qm-yes" data-qm-answer="yes">Yes</a>
                  <a href="#" id="qm-answer" class="qm-no" data-qm-answer="no">No</a>
              </div>
              </div>
          </div>
      </div>
    `;
  
    var returnProcess_HTML = `
    <div class="qm qm-return" style="display:none;">
        <div class="qm-wrapper">
        <a href="#" class="qm-close">
            <i class="fa-thin fa-xmark"></i>
        </a>
        <div class="qm-content">
        ` + returnProcess_Content + `
        </div>
        </div>
    </div>
    `;

    var howWeDidIt_HTML = `
    <div class="spt" style="display:none;">
      <div class="spt-container">
        <div class="spt-close">
          <a href="#" class="spt-close-link">
            <i class="fa-solid fa-xmark spt-close-icon"></i>
          </a>
        </div>
        <div class="spt-content">
          ` + howWeDidIt_Content + `
        </div>
      </div>
    </div>
    `;
  
    // ============= PREPEND
    $('body').prepend(qualityMatters_HTML);

    // Return Process
    $('body').prepend(returnProcess_HTML);
  
    // How We Did It
    $('body').prepend(howWeDidIt_HTML);
  
    // Replace the .dz-returns to this content
    $('.dz-returns').replaceWith('<div class="qm-section-wrapper"><div class="qm-btn-wrapper"><div class="qm-btn-holder"><a href="#" style="display: inline-block;" class="quality-matters"><i class="fa-thin fa-award"></i>&nbsp;Why Does Quality Matter?</a></div><div class="qm-btn-holder"><a href="#" class="dz-returns"><i class="fa-light fa-truck"></i>&nbsp;Our FREE RETURNS PROCESS</a></div></div></div>');

    // Add How We Did It Button
    $('.product-single__meta div[data-product-blocks]').append('<div class="product-block"><a href="#" class="sales-pitch-trigger"><i class="fa-thin fa-circle-question"></i> How We Did It</a></div>');
});

// Quality Matters
$(document).on('click', '.quality-matters', function(event) {
  event.preventDefault();
  $('.qm-matters').show();
});

// Return Process
$(document).on('click', '.dz-returns', function(event) {
  event.preventDefault();
  $('.qm-return').show();
});

// Long Pitch
$(document).on('click', '.sales-pitch-trigger', function(event) {
  event.preventDefault();
  $('.spt').show();
})

// Close Button
$(document).on('click', '.qm-close, .spt-close', function(event) {
  event.preventDefault();
  $(this).parent().parent().hide();
});

// Quality Matters Answer
$(document).on('click', '#qm-answer', function(event) {
  event.preventDefault();
  $('.qm-agree').hide();
});

$(document).on('click', '.spt .reveal', function(event) {
  event.preventDefault();
  $(this).text('$4000');
});

$(document).on('click', '.product-popup-close', function(event) {
  event.preventDefault();
  $(this).parent().parent().fadeOut();
});

$(document).on('click', '.product-popup-show', function(event) {
    event.preventDefault(); 
    var ppid = $(this).attr('id'); 
    $('#' + ppid).show(); 
});

// ================================= NEW POPUP ================================= 

$(document).ready(function() {
  // Open the lightbox and load the corresponding content
  $(document).on('click', '.dz-info-popup-btn', function(e) {
    e.preventDefault(); // Prevent default anchor behavior

    var targetId = $(this).attr('id').replace('-btn', ''); // Get the target ID without '-btn'
    var content = $('#' + targetId + '-content').html(); // Get the corresponding hidden content
    
    console.log(targetId);
    
    console.log(targetId + '-content');
    
    // Insert the content into the lightbox
    $('.dz-lightbox-content .product-block').html(content);

    // Check local storage to see if the user has already answered the question for this trigger
    var hasAnswered = localStorage.getItem(targetId + '-answered');

    // Show the agreement section only if the user hasn't answered the question
    if (hasAnswered) {
      $('.dz-agreement-section').hide(); // Hide agreement section if already answered
    } else if ($(this).hasClass('dz-info-agreement-active')) {
      $('.dz-agreement-section').show(); // Show agreement section if class is present and no answer yet
    }

    // Show the lightbox with display flex
    $('.dz-lightbox-content').css('display', 'flex').hide().fadeIn(); // Ensure display is set to flex, then fade in
  });

  // Close the lightbox
  $(document).on('click', '.dz-lightbox-content .dz-lightbox-close' ,function() {
    $('.dz-lightbox-content').fadeOut();
  });

  // Close lightbox when clicking outside the content
  $(document).on('click', '.dz-lightbox-content', function(e) {
    if ($(e.target).is('.dz-lightbox-content')) {
      $(this).fadeOut();
    }
  });

  // Handle Yes button click (store answer in localStorage)
  $(document).on('click', '.dz-agreement-section #yes-btn', function() {
    var triggerId = $('.dz-info-popup-btn.dz-info-agreement-active').attr('id').replace('-btn', '');

    // Store the answer in localStorage
    localStorage.setItem(triggerId + '-answered', 'yes');

    alert('Thank you for agreeing with our stance on quality!');
    $('.dz-lightbox-content').fadeOut();
  });

  // Handle No button click (store answer in localStorage)
  $(document).on('click', '.dz-agreement-section #no-btn', function() {
    var triggerId = $('.dz-info-popup-btn.dz-info-agreement-active').attr('id').replace('-btn', '');

    // Store the answer in localStorage
    localStorage.setItem(triggerId + '-answered', 'no');

    alert('We appreciate your feedback!');
    $('.dz-lightbox-content').fadeOut();
  });
});